import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcSmart from '../components/calc/plisse/CalcSmart.svelte';
import PlisseCalcPlugin from '../components/calc/plisse/CalcPlugin.svelte';
import PlisseCalcCommon from '../components/calc/plisse/CalcCommon.svelte';
import PlisseCalcSlim from '../components/calc/plisse/CalcSlim.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import CalcPacking from '../components/calc/CalcPacking.svelte';
import PartPrice from '../components/parts/Price.svelte';
import PlisseCalcShtory from '../components/calc/plisse/CalcPlisseShtory.svelte';
import PlisseCalcAlumPro from '../components/calc/plisse/CalcAlumPro.svelte';

let list = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'moskitoscompany') {
    logo = 'moskitoscompany.jpg';
    precision = 1;

    list.push({
        title: 'Москитная система Pro 40',
        calc: 'Smart',
        img: '/img/plisse/setkipro/setki.pro_smart.png',
        description: 'Профиль: 40x25 мм. Длина волны сетки: 14-16 мм. Для проёмов размеров ШхВ 1600х2500 мм',
        link: 'smart',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            CalcPacking,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 6000,
                height: 3000
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антипыль',
            ]

        }
    });

    list.push({
        title: 'Москитная система Classic 20',
        calc: 'Slim',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'slim',
        component: PlisseCalcSlim,
        components: [
            PartPrice,
            CalcMounting,
            CalcPacking,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
            },
            max: {
                width: 2100,
                height: 2200
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антипыль',
            ]
        }
    });

    list.push({
        title: 'Вставная москитная сетка',
        calc: 'Вставная',
        img: '/img/plisse/setkipro/setki.pro_vstavnaya.png',
        description: 'Профиль: 30x25 мм. Для окон размеров 1000х2100 мм',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Анодированный(коньяк)': 'Анодированный(коньяк)',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
            },
            max: {
                width: 1300,
                height: 2200
            }
        }
    });

    list.push({
        title: 'Рамочная москитная сетка',
        calc: 'Обычная',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль: 25x19 мм. Для окон размеров 900х1800 мм',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
            },
            max: {
                width: 1000,
                height: 2100
            }
        }
    });

    list.push({
        title: 'Шторы плиссе',
        calc: 'Шторы плиссе',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе',
        component: PlisseCalcShtory,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2500

            },
            vStrukture: 36,


            shtorytypes: [
                'Полупрозрачная',
                'Не прозрачная (BLACKOUT)',
            ],

            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'белый',
                'серый',
                'коричневый',
                'черный',
            ],

             shtoryPoluprozcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'мокко',
                'антрацит',
            ],

            nitcolor:   [
            'белая',
            'серая',
            'кремовая',
            'бежевая',
            'темно-синий',
            'коричневая',
            'мокко',
            'антрацит',
        ],


            color:  {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Серый RAL 7040': 'Серый RAL 7040',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Серый Антрацит RAL 7016': 'Серый Антрацит RAL 7016',
                'Цветной': 'Цветной',
            }



        }
    });

    list.push({
        title: 'Москитная сетка АлюмПро',
        calc: 'АлюмПро',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль 25х17мм. Для алюминиевых окон без сверления 1000х2000мм',
        link: 'алюмпро',
        component: PlisseCalcAlumPro,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Гарфит(RAL7024)': 'Гарфит(RAL7024)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
            },
            max: {
                width: 1000,
                height: 2000
            }
        }
    });
}

export {list, logo, precision};
